import { post } from "../utils/request";
import axios from "axios";
const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;

export default {
  pageList: query => post("/open/course/getCoursePage", query),
  update: query => post("/open/course/update", query),
  select: id => post("/open/course/select/" + id),
  delete: id => post("/open/course/delete/" + id),

  getPage: query => post("/rrbi/coursefront/getPage", query),
};


export function fetchNewIndexCourseList({ id, cookies ,params}) {
  return axios.post(baseUrl + `/rrbi/coursefront/getPage`, params,{
    headers: getCommonHeader({ cookies })
  });
}





function getCommonHeader({ cookies }) {
  if (TARGET_SERVER && cookies) {
    return { cookie: getCookieString(cookies) };
  } else {
    return null;
  }
}

function getCookieString(cookies) {
  let cookieStr = "";
  for (var variable in cookies) {
    //if (Object.prototype.hasOwnProperty.call(cookies, "variable")) {
      cookieStr += `${variable}=${encodeURIComponent(cookies[variable])}; `;
    //}
  }
  return cookieStr;
}
